// WhatsApp-style chat date/time formatting (Asia/Kolkata)
const CHAT_TIME_ZONE = 'Asia/Kolkata';

function chatDatePartsInZone(dateString) {
  const date = dateString ? new Date(dateString) : new Date();
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: CHAT_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  const parts = formatter.formatToParts(date);
  const year = parts.find((p) => p.type === 'year').value;
  const month = parts.find((p) => p.type === 'month').value;
  const day = parts.find((p) => p.type === 'day').value;
  return { dateKey: `${year}-${month}-${day}` };
}

function chatTodayKeyInZone() {
  return chatDatePartsInZone(new Date().toISOString()).dateKey;
}

function chatRelativeDayLabel(dateKey) {
  const todayKey = chatTodayKeyInZone();
  const todayParts = todayKey.split('-').map(Number);
  const dayParts = dateKey.split('-').map(Number);
  const todayUtc = Date.UTC(todayParts[0], todayParts[1] - 1, todayParts[2]);
  const dayUtc = Date.UTC(dayParts[0], dayParts[1] - 1, dayParts[2]);
  const diffDays = Math.round((dayUtc - todayUtc) / 86400000);

  if (diffDays === 0) return 'Today';
  if (diffDays === -1) return 'Yesterday';
  if (diffDays === 1) return 'Tomorrow';

  return `${dayParts[2]}/${String(dayParts[1]).padStart(2, '0')}/${dayParts[0]}`;
}

function formatChatMessageTime(dateString) {
  const date = dateString ? new Date(dateString) : new Date();
  return new Intl.DateTimeFormat('en-US', {
    timeZone: CHAT_TIME_ZONE,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
}

function formatChatSidebarTime(dateString) {
  const { dateKey } = chatDatePartsInZone(dateString);
  const label = chatRelativeDayLabel(dateKey);
  if (label === 'Today') return formatChatMessageTime(dateString);
  return label;
}

function chatDateSeparatorLabel(dateString) {
  const { dateKey } = chatDatePartsInZone(dateString);
  return chatRelativeDayLabel(dateKey);
}

function formatTimestamp(dateString) {
  return formatChatMessageTime(dateString);
}

function chatDateSeparatorHtml(dateString) {
  const label = chatDateSeparatorLabel(dateString);
  return '<table class="table-live-chat chat-date-separator-table"><tr class="chat-date-separator-row">' +
    '<td style="text-align:center;border:none;padding:10px 0;">' +
    '<span class="chat-date-separator">' + label + '</span></td></tr></table>';
}

function chatConversationSearchRoot(appendContainerSelector) {
  const appendSelector = appendContainerSelector || '.append-live-message';
  if (appendSelector === '.append-live-message') {
    return $('.message-chatting-wrp-scroll');
  }
  const $append = $(appendSelector);
  const $root = $append.closest('.message-chatting-wrp-scroll, .live-chat-body, .chat').first();
  return $root.length ? $root : $append.parent();
}

function lastChatMessageDateKey($searchRoot) {
  const $lastMsg = $searchRoot.find('[data-msg-date]').last();
  return $lastMsg.length ? $lastMsg.attr('data-msg-date') : null;
}

function maybePrependChatDateSeparator(dateString, containerSelector) {
  const appendSelector = containerSelector || '.append-live-message';
  const { dateKey } = chatDatePartsInZone(dateString);
  const $appendContainer = $(appendSelector);
  const $searchRoot = chatConversationSearchRoot(appendSelector);
  const lastKey = lastChatMessageDateKey($searchRoot);

  if (lastKey === dateKey) return dateKey;

  $appendContainer.append(chatDateSeparatorHtml(dateString));
  return dateKey;
}

function updateChatSidebarTime(roomId, dateString) {
  if (!roomId) return;
  const $item = $(`.user-live-message[data-service='${roomId}']`);
  if ($item.length) {
    $item.find('.chat-sidebar-time').text(formatChatSidebarTime(dateString));
  }
}

const CHAT_TICK_SVG_PATH =
  'M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.29-2.5-2.95a.436.436 0 0 0-.327-.148.47.47 0 0 0-.381.179.445.445 0 0 0 .102.603l2.983 3.5a.437.437 0 0 0 .327.149.48.48 0 0 0 .382-.178l6.595-7.77a.42.42 0 0 0 .094-.6z';

function chatReadTicksHtml(seen) {
  const stateClass = seen ? 'msg-status-ticks--read' : 'msg-status-ticks--sent';
  const label = seen ? 'Read' : 'Delivered';
  const secondPath = seen
    ? `<path class="msg-tick-path msg-tick-path--second" fill="currentColor" d="${CHAT_TICK_SVG_PATH}" transform="translate(-4.25 0)"/>`
    : '';

  return (
    `<span class="msg-status-ticks ${stateClass}" title="${label}" aria-label="${label}">` +
    `<svg class="msg-tick-svg" viewBox="0 0 16 11" width="16" height="11" aria-hidden="true" focusable="false">` +
    `<path class="msg-tick-path msg-tick-path--first" fill="currentColor" d="${CHAT_TICK_SVG_PATH}"/>${secondPath}</svg></span>`
  );
}

function setChatReadTicks($el, seen) {
  if (!$el || !$el.length) return;
  $el.removeClass('msg-status-ticks--sent msg-status-ticks--read')
    .addClass(seen ? 'msg-status-ticks--read' : 'msg-status-ticks--sent')
    .attr('title', seen ? 'Read' : 'Delivered')
    .attr('aria-label', seen ? 'Read' : 'Delivered')
    .html(
      `<svg class="msg-tick-svg" viewBox="0 0 16 11" width="16" height="11" aria-hidden="true" focusable="false">` +
      `<path class="msg-tick-path msg-tick-path--first" fill="currentColor" d="${CHAT_TICK_SVG_PATH}"/>` +
      (seen ? `<path class="msg-tick-path msg-tick-path--second" fill="currentColor" d="${CHAT_TICK_SVG_PATH}" transform="translate(-4.25 0)"/>` : '') +
      '</svg>'
    );
}

window.chatDatePartsInZone = chatDatePartsInZone;
window.chatReadTicksHtml = chatReadTicksHtml;
window.setChatReadTicks = setChatReadTicks;
window.formatChatMessageTime = formatChatMessageTime;
window.formatChatSidebarTime = formatChatSidebarTime;
window.formatTimestamp = formatTimestamp;
window.chatDateSeparatorLabel = chatDateSeparatorLabel;
window.maybePrependChatDateSeparator = maybePrependChatDateSeparator;
window.updateChatSidebarTime = updateChatSidebarTime;
